import {
  CREATE_MESSAGE,
  UPDATE_MESSAGE,
  IMPORT_MESSAGES
} from './mutations-types'
export default {
  createMessage ({ commit }, payload) {
    const id = Math.ceil(Math.random() * (1000 - 1) + 1)
    const message = Object.assign(payload, { id })
    commit(CREATE_MESSAGE, message)
  },
  updateMessage ({ commit }, payload) {
    commit(UPDATE_MESSAGE, payload)
  },
  importMessages ({ commit }, payload) {
    commit(IMPORT_MESSAGES, payload)
  }
}
